<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("ai_analytics_servers.status_active")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="statusActiveFilter"
          :options="statusOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:statusActiveFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("ai_analytics_servers.cameras_online")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="camerasOnlineFilter"
          :options="statusOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:camerasOnlineFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          :clearable="true"
        />
      </b-col>
      <!--<b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("ai_analytics_servers.start_date") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="startDateFilter"
            @on-change="(selectedDates, val) => $emit('update:startDateFilter', val)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md="6" class="mb-md-0 mb-2">
        <b-form-group>
          <label class="text-capitalize">
            {{ $t("ai_analytics_servers.end_date") }}
          </label>
          <flat-pickr
            class="form-control"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i:s',
              time_24hr: true,
            }"
            :value="endDateFilter"
            @on-change="(selectedDates, val) => $emit('update:endDateFilter', val)"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" class="mb-2">
        <CamerasProxySelect
          :value="cameraFilter"
          @input="(val) => $emit('update:cameraFilter', val)"
          :label="$tc('ai_analytics_servers.device', 2)"
          :multiple="true"
          :reduce="(val) => val.value"
        />
      </b-col>-->
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import CamerasProxySelect from "@/components/CamerasProxySelect.vue";
import flatPickr from "vue-flatpickr-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    CamerasProxySelect,
    flatPickr,
  },
  props: {
    cameraFilter: {
      type: Array,
      default: () => [],
    },
    cameraOptions: {
      type: Array,
      default: () => [],
    },
    statusActiveFilter: {
      type: Boolean,
      default: null,
    },
    camerasOnlineFilter: {
      type: Boolean,
      default: null,
    },
    startDateFilter: {
      type: String,
      default: null,
    },
    endDateFilter: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { t } = useI18nUtils();

    const statusOptions = [
      { label: t("ai_analytics_servers.online"), value: true },
      { label: t("ai_analytics_servers.offline"), value: false },
    ];

    return {
      withPopper: popperHelper.withPopper,
      statusOptions,
    };
  },
};
</script>
